import { gql } from 'apollo-boost'

const GET_NEXT = gql`
	query GET_NEXT($code: String!) {
		next(code: $code)
	}
`

export { GET_NEXT }
